import { TablePagination } from '@mui/material'
import { PodiumFleetPagination } from '@types'
import { PER_PAGE_OPTIONS } from './pageSizes'

interface Props {
    /** The server's length-aware block; null while the first page is still loading. */
    pagination: PodiumFleetPagination | null
    onChange: (page: number, perPage: number) => void
}

/**
 * Page controls for the detail page's two card lists, matching the DataGrid footer used
 * everywhere else in the console.
 *
 * Habitat Admin pages are 1-indexed and `TablePagination` is 0-indexed, so the conversion
 * happens here and nowhere else.
 */
export default function CardPagination({ pagination, onChange }: Props) {
    if (!pagination || pagination.total === 0) return null

    return (
        <TablePagination
            component="div"
            count={pagination.total}
            page={pagination.currentPage - 1}
            rowsPerPage={pagination.perPage}
            rowsPerPageOptions={PER_PAGE_OPTIONS}
            onPageChange={(_e, page) => onChange(page + 1, pagination.perPage)}
            // Changing the page size renumbers every page, so go back to the first one
            // rather than landing on whatever now sits at the old page number.
            onRowsPerPageChange={(e) => onChange(1, Number(e.target.value))}
            sx={{ mt: 1 }}
        />
    )
}
